// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"app-components-Modal-__Modal___2b7N4","modal-body":"app-components-Modal-__Modal___3K4AZ","old-reason-field":"app-components-Modal-__Modal___1t3qL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Modal/Modal.css
// module id = 532
// module chunks = 0